<script>
  import Contact from './Contact.svelte';

  export let contacts;
  export let lang = undefined;
</script>

<div class='contacts-box'>
  {#each contacts as contact}
    <Contact value={contact} bind:lang/>
  {/each}
</div>

<style>
  .contacts-box {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    padding: 20px;

    border-radius: 5px;

    background: var(--grey-1);
  }

  :global(body.dark) .contacts-box {
    background: var(--grey-8);
  }
</style>
